import React, { Component } from "react";
import PropTypes from "prop-types";
import autoBind from "react-autobind";
import { withFormsy } from "formsy-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class DateTimePicker extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onDatepickerRef(el) {
    if (el && el.input) {
      el.input.readOnly = true;
    }
  }

  updateValue = async data => {
    await this.props.onChange(data, this.props.name);
    await this.props.setValue(this.props.value);
  };

  render() {
    let {
      name,
      placeholderText,
      label,
      value,
      interval,
      required,
      disabled,
      valid
    } = this.props;

    name = name.replace(/_/g, " ");
    let fieldLabel = required ? (label += " *") : label;
    const errorMessage = !valid && this.props.getErrorMessage();

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <DatePicker
          ref={el => this.onDatepickerRef(el)}
          className="form-control"
          selected={value ? moment(value) : null}
          onChange={this.updateValue}
          placeholderText={placeholderText ? placeholderText : "Enter time"}
          showTimeSelect
          fixedHeight
          disabled={disabled}
          locale="en-us"
          timeFormat="hh:mm A"
          timeIntervals={interval ? interval : 15}
          dateFormat="LLL"
          timeCaption="Time"
        />
        <span className="validation-message">{errorMessage}</span>
      </div>
    );
  }
}

DateTimePicker.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholderText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  required: PropTypes.bool
};

export default withFormsy(DateTimePicker);
